"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _utils = require("@/utils");
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _exportFile = require("@/api/common/exportFile");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ExportBtn',
  component: {
    dragDialog: _DragDialog.default
  },
  props: {
    // 按钮名，默认导出
    btnTitle: {
      type: String,
      default: ''
    },
    // 导出文件名，默认exportTableData
    exportFileName: {
      type: String,
      default: 'exportTableData'
    },
    // 导出表格对象
    tableObject: {
      type: Object,
      required: true
    },
    // 获取导出数据方法
    getTableData: {
      type: Function,
      required: true
    },
    // 过滤表格列map
    tableFilterColumn: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 展示导出已选按钮
    showSelected: {
      type: Boolean,
      default: true
    },
    // 展示导出导出全部按钮
    showExportAll: {
      type: Boolean,
      default: true
    },
    // 展示导出当前页按钮
    showExportCurrent: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      flagList: [],
      classList: [],
      vesselTypeList: [],
      poolTypeList: [],
      visible: false,
      exportForm: {
        beginPage: null,
        endPage: null,
        exportType: 'currentPage'
      },
      rules: {
        beginPage: {
          type: 'number',
          required: false,
          message: '请选择时间',
          trigger: 'change'
        }
      },
      loading: null
    };
  },
  watch: {
    visible: {
      handler: function handler(val) {
        console.log('tableFilterColumn', this.tableFilterColumn);
      },
      immediate: true
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['POOL_TYPE', 'POOL_TYPE_OF_VESSEL', 'POOL_CLASS', 'POOL_VESSEL_FLAG'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.poolTypeList = res.POOL_TYPE;
      _this.vesselTypeList = res.POOL_TYPE_OF_VESSEL;
      _this.classList = res.POOL_CLASS;
      _this.flagList = res.POOL_VESSEL_FLAG;
    });
  },
  methods: {
    showName: _utils.showName,
    handleClose: function handleClose() {
      this.$refs.exportForm.resetFields();
      this.visible = false;
    },
    /* 导出 */handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = (0, _utils.load)();
              data = [];
              _context.next = 4;
              return this.getTableData(this.exportForm.exportType);
            case 4:
              data = _context.sent;
              this.loading.close();
              if (!(!data.length && data.length < 1)) {
                _context.next = 12;
                break;
              }
              if (!(this.exportForm.exportType === 'selected')) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return", this.$message({
                type: 'warning',
                message: this.$t('excel.chooseOneMsg')
              }));
            case 11:
              return _context.abrupt("return", this.$message.warning(this.$t('com.noResultToReport')));
            case 12:
              this.exportFun(data, this.tableFilterColumn);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    exportFun: function exportFun(data, filterColumn) {
      var that = this;
      var exportCol = that.tableObject.$children.map(function (item) {
        if (item.data !== undefined && item.data && typeof item.data === 'string') {
          return item.data;
        } else if (item.prop !== undefined && item.prop && typeof item.prop === 'string') {
          return item.prop;
        }
      }).filter(function (_) {
        return _;
      });
      var exportColTitle = that.tableObject.$children.map(function (item) {
        if (item.data !== undefined && typeof item.data === 'string') {
          return (0, _defineProperty2.default)({}, item.data, item.title);
        } else if (item.prop !== undefined && typeof item.prop === 'string') {
          return (0, _defineProperty2.default)({}, item.prop, item.label);
        }
      }).filter(function (_) {
        return _;
      });
      var exportData = [];
      console.log('data,', data, exportCol);
      for (var i = 0; i < data.length; i++) {
        var ele = data[i]; // {}
        exportData[i] = {};
        for (var key in ele) {
          var con = ele[key];
          if (exportCol.includes(key)) {
            exportData[i][key] = con;
          }
        }
      }
      this.downExcel({
        exportData: exportData,
        titles: exportColTitle,
        filterColumn: filterColumn
      });
    },
    downExcel: function downExcel(query) {
      var _this2 = this;
      var that = this;
      this.loading = (0, _utils.load)();
      (0, _exportFile.exportTableData)(query).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res], {
          type: 'application/x-execl'
        }));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', _this2.exportFileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        _this2.$message({
          type: 'success',
          message: _this2.$t('excel.exportSuccess')
        });
        that.visible = false;
        that.$refs.exportForm.resetFields();
      }).finally(function () {
        _this2.loading.close();
      });
    }
  }
};